<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12">
              <a-form-item label="参数名称">
                <a-input v-model="query.pmtName" placeholder="请输入参数名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="设备名称">
                <a-input v-model="query.deviceName" placeholder="请输入设备名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()">新增</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :data-source="list"
        :pagination="pagination"
        @change="pageChange"
        bordered
      >
        <span slot="action" slot-scope="text, record">
          <a @click="Handle(record)">编辑</a>
        </span>
        <span slot="openState" slot-scope="text">
          <a-tag color="#f12b35" v-if="text == 0">不开启</a-tag>
          <a-tag color="rgb(50, 205, 50)" v-else>开启</a-tag>
        </span>
      </a-table>
      <a-modal :title="this.title" width="50%" v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
        <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="是否开启报警">
            <a-radio-group
              v-decorator="['openState', { initialValue: 0, rules: [{ required: true }] }]"
              style="width: 100%"
            >
              <a-radio :value="0">不开启</a-radio>
              <a-radio :value="1">开启</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="参数名称">
            <a-select
              disabled
              v-decorator="['pmtId', { rules: [{ required: true, message: '请选择参数名称' }] }]"
              placeholder="压力"
            >
              <a-select-option v-for="(item, index) in parameterList" :key="index" :value="item.key">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="设备名称" v-if="onChvalue">
            <div class="pressure-alarm-device-select-wrap">
              <a-select
                class="pressure-alarm-device-select"
                :disabled="disabled"
                v-decorator="['deviceId', { rules: [{ required: true, message: '请选择设备名称' }] }]"
                placeholder="请选择设备名称"
                show-search
                option-filter-prop="children"
                :filter-option="filterDeviceOption"
                :get-popup-container="(trigger) => trigger.parentNode"
                dropdown-class-name="pressure-alarm-device-select-dropdown"
              >
                <a-select-option
                  v-for="(item, index) in equipmentList"
                  :key="index"
                  :value="item.key"
                  :title="item.title"
                >
                  {{ item.title }}
                </a-select-option>
              </a-select>
              <a class="pressure-alarm-device-copy-link" href="javascript:;" @click="copyDeviceDisplayName">复制名称</a>
            </div>
          </a-form-item>
         
          <a-form-item label="报警值最大值">
            <a-input v-decorator="['alarmValueMax', { rules: [{ required: true, message: '请输入报警值最大值!' }] }]" />
          </a-form-item>
          <a-form-item label="预警值最大值">
            <a-input v-decorator="['earlyValueMax', { rules: [{ required: true, message: '请输入预警值最大值!' }] }]" />
          </a-form-item>
          <a-form-item label="预警值最小值" v-if="onChvalue">
            <a-input v-decorator="['earlyValueMin', { rules: [{ required: true, message: '请输入预警值最小值!' }] }]" />
          </a-form-item>
          <a-form-item label="报警值最小值" v-if="onChvalue">
            <a-input v-decorator="['alarmValueMin', { rules: [{ required: true, message: '请输入报警值最小值!' }] }]" />
          </a-form-item>

          <span style="text-align: center; display: block; color: #e01414"
            >报警最大值 > 预警最大值 > 预警最小值 > 报警最小值</span
          >
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      /** 压力表报警固定参数：压力（sysType 压力表），不可修改 */
      FIXED_PRESSURE_PMT_ID: '1512346469213470725',
      currentId: '',
      isUpdate: false,
      disabled: false,
      onChvalue: true,
      equipmentList: [],
      parameterList: [],
      title: '新增',
      queryUrl: '/pipe-network/alarm_tsl_configs/page',
      modifyUrl: '/pipe-network/alarm_pmt_configs',
      addOrUpdateUrl: '/pipe-network/alarm_tsl_configs',
      deleteUrl: '/pipe-network/alarm_tsl_configs', // 删除数据url
      queryOneUrl: '/pipe-network/alarm_tsl_configs',
      visible: false,
      confirmLoading: false,
      list: [],
      typelist: ['加压设备', '加药设备', '其它设备'],
      query: {
        deviceType: '',
        deviceNo: '',
        deviceName: '',
        pmtName: '',
        sysType: '压力表',
        tenantId: this.$store.state.user.info.tenantId
      },
      columns: [
        {
          title: '设备名称',
          dataIndex: 'deviceName'
        },
        {
          title: '参数名称',
          dataIndex: 'pmtName'
        },
        {
          title: '是否开启报警',
          dataIndex: 'openState',
          scopedSlots: { customRender: 'openState' }
        },
        // {
        //   title: '正常值',
        //   dataIndex: 'normalValue',
        // },
        {
          title: '报警最小值',
          dataIndex: 'alarmValueMin'
        },
        {
          title: '预警最小值',
          dataIndex: 'earlyValueMin'
        },
        {
          title: '报警最大值',
          dataIndex: 'alarmValueMax'
        },
        {
          title: '预警最大值',
          dataIndex: 'earlyValueMax'
        },
        {
          title: '更改时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }
      ],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },
  mounted() {
    this.queryList()
  },
  created() {
    this.equipmentSelect()
    this.parameterSelect()
    this.resetList()
  },
  methods: {
    filterDeviceOption(input, option) {
      const text =
        option.componentOptions &&
        option.componentOptions.children &&
        option.componentOptions.children[0] &&
        option.componentOptions.children[0].text
      if (!text) return false
      return String(text).toLowerCase().indexOf(String(input).toLowerCase().trim()) >= 0
    },
    copyDeviceDisplayName() {
      const deviceId = this.addOrUpdateForm.getFieldValue('deviceId')
      if (deviceId === undefined || deviceId === null || deviceId === '') {
        this.$message.warning('请先选择设备')
        return
      }
      const item = this.equipmentList.find((e) => String(e.key) === String(deviceId))
      const text = item ? item.title : String(deviceId)
      const ok = () => this.$message.success('已复制到剪贴板')
      const err = () => this.$message.error('复制失败，请重试')
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(text).then(ok).catch(err)
        return
      }
      const ta = document.createElement('textarea')
      ta.value = text
      ta.setAttribute('readonly', 'readonly')
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      try {
        if (document.execCommand('copy')) {
          ok()
        } else {
          err()
        }
      } catch (e) {
        err()
      }
      document.body.removeChild(ta)
    },
    equipmentSelect() {
      this.$http.get('/pipe-network/piezometer/list').then((res) => {
        let list = []
        res.data.map((item) => {
          console.log(item)
          list.push({
            title: item.piezometerNo + ' ' + item.installAddress,
            key: item.id
          })
        })
        this.equipmentList = list
        console.log(this.equipmentList, 'sdfsdffdsfsdf')
      })
    },
    parameterSelect() {
      const params = {
        sysType: '压力表'
      }
      this.$http.get('/pipe-network/alarm_pmt_configs/list', { params }).then((res) => {
        console.log(res.data, 'kkk')
        let list = []
        ;(res.data || []).map((item) => {
          list.push({
            title: item.name,
            key: item.id
          })
        })
        const fixedId = String(this.FIXED_PRESSURE_PMT_ID)
        if (!list.some((i) => String(i.key) === fixedId)) {
          list.unshift({ title: '压力', key: fixedId })
        }
        this.parameterList = list
      })
    },
    addOrUpdateHandle(id) {
      this.isUpdate = false
      this.isEditMode = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      this.onChvalue = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.addOrUpdateForm.setFieldsValue(data)
            if (String(data.pmtId) === '1512346469213470724') {
              this.onChvalue = false
            } else {
              this.onChvalue = true
            }
          })
          .catch(() => {})
      } else {
        this.$nextTick(() => {
          this.addOrUpdateForm.setFieldsValue({
            pmtId: this.FIXED_PRESSURE_PMT_ID
          })
        })
      }
    },
    handleChange(e) {},
    Handle(record) {
      this.title = '编辑'
      if (record.pmtId == '1512346469213470724') {
        this.onChvalue = false
      } else {
        this.onChvalue = true
      }
      this.disabled = true
      this.addOrUpdateHandle(record.id)
      this.showModal()
      this.resetList()
    },
    showModal() {
      this.visible = true
    },
    modify(values) {
      console.log(values, 'fsdfs')
      let params = {
        // id: values.id,
        deviceName: values.deviceName,
        temperatureMin: values.temperatureMin,
        voltageMax: values.voltageMax,
        voltageMin: values.voltageMin,
        electricityMax: values.electricityMax,
        electricityMin: values.electricityMin,
        waterLevelMax: values.waterLevelMax,
        waterLevelMin: values.waterLevelMin
      }
      const header = {
        'Content-Type': 'application/json',
        Authorization: this.token
      }
      this.$http({
        url: this.modifyUrl,
        data: params,
        headers: header,
        method: 'post'
      }).then((data) => {
        this.queryList()
        this.visible = false
        this.visible = false
        this.confirmLoading = false
        this.$message.success('设置成功')
      })
    },
    //取消
    handleCancel(e) {
      this.title = '新增'
      this.addOrUpdateVisible = false
      this.disabled = false
      this.onChvalue = true
      this.addOrUpdateForm.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
/deep/ .ant-table-thead > tr > th > {
  text-align: center;
}

/deep/ .ant-table-tbody > tr > td {
  text-align: center;
}

/* 框选复制：禁用态下 ant-select 常带 pointer-events:none / user-select:none，需覆盖 */
/deep/ .pressure-alarm-device-select.ant-select .ant-select-selection,
/deep/ .pressure-alarm-device-select.ant-select .ant-select-selection__rendered,
/deep/ .pressure-alarm-device-select.ant-select .ant-select-selection-selected-value,
/deep/ .pressure-alarm-device-select.ant-select .ant-select-search__field {
  user-select: text !important;
  -webkit-user-select: text !important;
}
/deep/ .pressure-alarm-device-select.ant-select-disabled .ant-select-selection,
/deep/ .pressure-alarm-device-select.ant-select-disabled .ant-select-selection__rendered {
  pointer-events: auto !important;
  cursor: text;
}
/deep/ .pressure-alarm-device-select.ant-select-disabled .ant-select-selection-selected-value {
  pointer-events: auto !important;
  user-select: text !important;
  -webkit-user-select: text !important;
}

/deep/ .pressure-alarm-device-select-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}
/deep/ .pressure-alarm-device-select-wrap .pressure-alarm-device-select {
  flex: 1;
  min-width: 0;
}
/deep/ .pressure-alarm-device-copy-link {
  flex-shrink: 0;
  white-space: nowrap;
}
</style>

<style lang="less">
/* 下拉挂载在 body 时需全局类名，选项文字可框选复制 */
.pressure-alarm-device-select-dropdown .ant-select-dropdown-menu-item {
  user-select: text !important;
  -webkit-user-select: text !important;
}
</style>
